Bingo.Map.NearbyPlaces = function (mapMarkerList, selectNearbyPlacesElement, locationId, locationLink) {
    this._map = mapMarkerList.getArea();
    this._mainMarker = mapMarkerList.list[0];
    this._locationLink = locationLink;
    this._locationId = locationId;
    this._markers = [];
    this._places = {};
    this._infoWindow = null;
    this._placesSelected = [];
    this.ONE_MARKER_ZOOM_LEVEL = 14;

    if (this._locationId !== null && this._locationLink !== null) {
        this.bindWithDOM(selectNearbyPlacesElement);
    }
};

Bingo.Map.NearbyPlaces.prototype = Object.create(Bingo.Map.Instance.prototype);

/**
 * Binds action to DOM elements
 * @param selectNearbyPlacesElement
 */
Bingo.Map.NearbyPlaces.prototype.bindWithDOM = function (selectNearbyPlacesElement) {
    $(selectNearbyPlacesElement).on('click', 'span.js-mapOnDetail__labelsControlItem', (event) => {
        const nearbyPlacesControlItem = $(event.target);
        const nearbyPlacesType = nearbyPlacesControlItem.data('id');
        let processingAjaxRequest = false;

        // control item doesn't have mandatory type data
        if (typeof nearbyPlacesType === 'undefined') {
            return;
        }

        if (nearbyPlacesControlItem.hasClass('-active')) {
            // control item is now inactive
            this._placesSelected.splice($.inArray(nearbyPlacesType, this._placesSelected), 1);
        } else if (!(nearbyPlacesType in this._places)) {
            // control item is now active but nearby places of selected type haven't yet been requested from server

            // we need to wait for ajax request to successfully finish before rendering outputs
            processingAjaxRequest = true;

            $.ajax({
                type: 'GET',
                url: this._locationLink,
                data: {
                    locationId: this._locationId,
                    locationTypeCode: nearbyPlacesType,
                },
                success: (returnedPlaces) => {
                    this._places[nearbyPlacesType] = returnedPlaces;
                    this._placesSelected.push(nearbyPlacesType);
                    this.loadPlaces(this._placesSelected);
                },
            });
        } else {
            // control item is now active and nearby places of selected type have been already requested from server
            this._placesSelected.push(nearbyPlacesType);
        }

        nearbyPlacesControlItem.toggleClass('-active');

        if (processingAjaxRequest === false) {
            if (this._placesSelected.length > 0) {
                this.loadPlaces(this._placesSelected);
            } else {
                this.resetMap();
            }
        }
    });
};

/**
 * Loads places from google places API, or cache
 * @param selectedPlaceTypes
 */
Bingo.Map.NearbyPlaces.prototype.loadPlaces = function (selectedPlaceTypes) {
    this.hideMarkers();
    const bounds = new google.maps.LatLngBounds();
    $.each(selectedPlaceTypes, (index, placeType) => {
        if (typeof this._places[placeType] === 'undefined') {
            return;
        }
        if (this._places[placeType].length > 0) {
            this.displayPlaces(bounds, this._places[placeType], placeType);
        }
    });
    this._map.fitBounds(bounds);
};

/**
 * Displays loaded places
 * @param bounds
 * @param places
 * @param placeType
 */
Bingo.Map.NearbyPlaces.prototype.displayPlaces = function (bounds, places, placeType) {
    //  takes all of the places and fit them to screen
    bounds.extend(this._mainMarker.position);

    places.forEach((place) => {
        bounds.extend(place.geometry.location);
        const marker = new google.maps.Marker({
            position: place.geometry.location,
            map: this._map,
            icon: {
                url: Bingo.Map.markerIconTypes[placeType],
            },
        });

        marker.addListener('click', () => {
            if (this._infoWindow) {
                this._infoWindow.close();
            }
            this._infoWindow = new google.maps.InfoWindow({
                content: `${'<div class="content">'
                + '<a href="'}${this.createLinkToGoogleMaps(place)}" target="_blank">${
                    place.name
                }</a>${
                    this.getMarkersDistanceFromCentralMarker(place.geometry.location)
                }</div>`,
            });
            this._infoWindow.open(this._map, marker);
        });

        this._markers.push(marker);
    });
};

/**
 * Hides all markers, to allow display of chosen type
 */
Bingo.Map.NearbyPlaces.prototype.hideMarkers = function () {
    for (let i = 0; i < this._markers.length; i++) {
        this._markers[i].setMap(null);
    }
};

/**
 * Creates link to google maps to given place
 * @param place
 * @returns {string}
 */
Bingo.Map.NearbyPlaces.prototype.createLinkToGoogleMaps = function (place) {
    let link = 'https://www.google.com/maps/search/?api=1';

    if (place.geometry.location.lat instanceof Function) {
        link += `&query=${place.geometry.location.lat()},${place.geometry.location.lng()}`;
    } else {
        link += `&query=${place.geometry.location.lat},${place.geometry.location.lng}`;
    }

    link += `&query_place_id=${place.place_id}`;

    return link;
};

/**
 * Computes distance of location to central marker
 * @param location
 * @returns {string}
 */
Bingo.Map.NearbyPlaces.prototype.getMarkersDistanceFromCentralMarker = function (location) {
    let lat = 0;
    let lng = 0;

    if (location.lat instanceof Function) {
        lat = location.lat();
        lng = location.lng();
    } else {
        lat = location.lat;
        lng = location.lng;
    }

    const R = 6371; // Radius of the earth in km
    const dLat = this.deg2rad(this._mainMarker.position.lat() - lat);
    const dLon = this.deg2rad(this._mainMarker.position.lng() - lng);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
        + Math.cos(this.deg2rad(lat)) * Math.cos(this.deg2rad(this._mainMarker.position.lat()))
        * Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = (R * c); // Distance in m
    if (d < 10) {
        return ` (${Math.round(d * 1000)} m)`;
    }
    return ` (${Math.round(d)} km)`;
};

/**
 * Converts degrees to radians
 * @param deg
 * @returns {number}
 */
Bingo.Map.NearbyPlaces.prototype.deg2rad = function (deg) {
    return deg * (Math.PI / 180);
};

/**
 * Hides all markers and reset map to initial position
 */
Bingo.Map.NearbyPlaces.prototype.resetMap = function () {
    this.hideMarkers();
    const bounds = new google.maps.LatLngBounds();
    bounds.extend(this._mainMarker.position);
    this._map.fitBounds(bounds);
    this._map.setZoom(this.ONE_MARKER_ZOOM_LEVEL);
};
